export default {
    items: [],
    categories: []
}
